// React Basic and Bootstrap
import React, {Component} from 'react';
import {Container} from 'reactstrap';

//Import Components
import SectionTitle from "../../components/Shared/SectionTitle";
import ReviewsSlider from "../../components/Shared/ReviewsSlider";

//Import Images
import img1 from "../../assets/images/client/01.jpg";
import img2 from "../../assets/images/client/02.jpg";
import img3 from "../../assets/images/client/03.jpg";
import img4 from "../../assets/images/client/04.jpg";
import img5 from "../../assets/images/client/05.jpg";
import img6 from "../../assets/images/client/06.jpg";

// Blog Images
import blog1 from '../../assets/images/blog/01.jpg';
import blog2 from '../../assets/images/blog/02.jpg';
import blog3 from '../../assets/images/blog/03.jpg';

class Testi extends Component {
    constructor(props) {
        super(props);
        this.state = {
            reviews: [
                {
                    id: 1,
                    img: img1,
                    name: "Eliud Mbugua",
                    post: "Customer Service Representative",
                    desc: "I can't thank you enough for your support throughout my job application process. From the initial consultation to my final placement, your team was professional, patient, and truly committed to helping me succeed. Today, I’m working in Belgrade in a role I love, and it's all thanks to your dedication and guidance.",
                    rating: 5
                },
                {
                    id: 2,
                    img: img2,
                    name: "Grace Wanjiku",
                    post: "Warehouse Assistant",
                    desc: "Finding a job abroad felt overwhelming until I connected with your company. You made everything clear and simple—helping with paperwork, interview prep, and even accommodation advice. I’m now happily employed in Novi Sad, and I couldn’t have done it without your help. Thank you for changing my life!",
                    rating: 5
                },
                {
                    id: 3,
                    img: img3,
                    name: "Josphat Macharia",
                    post: "Hotel Staff",
                    desc: "I had been searching for overseas opportunities for months with no luck. Then I found your agency, and within weeks, I had interviews lined up. Your team was incredibly responsive and encouraging. Now I’m working in Serbia with a stable income and a bright future. Thank you for making this possible!",
                    rating: 5
                },
                // {
                //     id: 4,
                //     img: img4,
                //     name: "Christa Smith",
                //     post: "Manager",
                //     desc: "According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero.",
                //     rating: 5
                // },
                // {
                //     id: 5,
                //     img: img5,
                //     name: "Dean Tolle",
                //     post: "Developer",
                //     desc: "There is now an abundance of readable dummy texts. These are usually used when a text is required.",
                //     rating: 5
                // },
                // {
                //     id: 6,
                //     img: img6,
                //     name: "Jill Webb",
                //     post: "Designer",
                //     desc: "Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts.",
                //     rating: 4
                // },
            ],
            blogs: [
                {
                    id: 1,
                    image: blog1,
                    title: "Design your apps in your own way",
                    like: "33",
                    comment: "08",
                    autor: "Calvin Carlo",
                    date: "13th August, 2019"
                },
                {
                    id: 2,
                    image: blog2,
                    title: "How apps is changing the IT world",
                    like: "33",
                    comment: "08",
                    autor: "Calvin Carlo",
                    date: "13th August, 2019"
                },
                {
                    id: 3,
                    image: blog3,
                    title: "Smartest Applications for Business",
                    like: "33",
                    comment: "08",
                    autor: "Calvin Carlo",
                    date: "13th August, 2019"
                },
            ]
        }
    }

    render() {
        return (
            <React.Fragment>
                <section className="section bg-light">
                    <Container>
                        {/* section title */}
                        <SectionTitle
                            title="Client Reviews"
                            desc="See examples of our past projects and success stories across various industries. Our
                                    portfolio showcases our commitment to delivering top-notch solutions tailored to our
                                    clients' unique needs."/>

                        {/* clients slider */}
                        <ReviewsSlider reviews={this.state.reviews} colClass="mt-4"/>
                    </Container>
                </section>
            </React.Fragment>
        );
    }
}

export default Testi;
